import React from "react";
import CText from "./CText";
import CButton from "./CButton";
import Box from "@mui/material/Box";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const CDialog = ({
  cOpen,
  cHandleClose,
  cTitle,
  cOnSubmitClick,
  cDialogContent,
  cDialogWidth = "sm",
  error = false,
  cHeaderContent,
}) => {
  const dialogWidthMapping = {
    xs: "800px",
    sm: "1000px",
    md: "1200px",
    lg: "1500px",
    xl: "1800px",
  };

  const dialogWidth = dialogWidthMapping[cDialogWidth] || dialogWidthMapping.md;

  const buttonStyle = {
    "& > span > button": {
      background:
        "linear-gradient(135deg, #042560 0%, #042560 100%) !important",
      color: "#ffffff !important",
      borderRadius: "10px !important",
      fontWeight: "700 !important",
      textTransform: "none !important",
      boxShadow: "0 8px 20px rgba(15, 76, 206, 0.25) !important",
      transition: "all 0.2s ease !important",
      "&:hover": {
        transform: "translateY(-2px) !important",
        boxShadow: "0 12px 24px rgba(37, 99, 235, 0.35) !important",
      },
    },
  };

  return (
    <Dialog
      open={cOpen}
      style={{ zIndex: 1200 }}
      PaperProps={{
        style: {
          width: dialogWidth,
          maxWidth: "100%",
        },
      }}
    >
      <DialogTitle>
        <CText cText={cTitle} cVariant="header_card" error={error} />
      </DialogTitle>

      {cHeaderContent && (
        <div style={{ padding: "0 24px 16px" }}>{cHeaderContent}</div>
      )}

      <DialogContent>{cDialogContent}</DialogContent>

      <DialogActions>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            px: 1,
            pb: 1,
            ...buttonStyle,
          }}
        >
          <CButton cOnClick={cHandleClose} cText="Close" />
          {cOnSubmitClick && (
            <CButton cOnClick={cOnSubmitClick} cText="Submit" />
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CDialog;